<mat-dialog-content>
    <sk-restored-items
        [job]="job">
    </sk-restored-items>
</mat-dialog-content>